import get from '../../../common/services/api/get';

export default function getRecentlySearchedItems(searchType) {
    return get(`/ui/users/preferences/recently_searched?type=${searchType}`);
}
